import Vue from 'vue'
import VueRouter from 'vue-router'
import HttpService from '@/services/http.service'
import store from '@/store'
import Dashboard from '@/views/dashboard/Dashboard'
import middlewarePipeline from '@/router/middlewarePipeline'
import auth from '@/router/middlewares/auth'
import loggedIn from '@/router/middlewares/loggedIn'
import role from '@/router/middlewares/role'

Vue.use(VueRouter)
Vue.use(HttpService)
const routes = [
  {
    path: '/',
    name: 'main',
    component: () => import('../views/Main.vue'),
    meta: {
      middleware: [
        loggedIn
      ]
    }
  },
  {
    path: '/dashboard',
    component: Dashboard,
    name: 'dashboard',
    meta: {
      middleware: [
        auth,
        role
      ]
    },
    children: [
      {
        path: '/dashboard/admin',
        component: () => import('../views/dashboard/admin/Dashboard'),
        beforeEnter: (to, from, next) => {
          if (store.getters.GET_USER && store.getters.GET_USER.role.includes('admin')) {
            return next()
          } else {
            return next({
              name: 'dashboard'
            })
          }
        },
        meta: {
          middleware: [
            auth
          ]
        },
        children: [
          {
            path: '',
            component: () => import('../views/dashboard/admin/Main'),
            name: 'dashboard.admin'
          },
          {
            path: '/dashboard/admin/requests',
            component: () => import('../views/dashboard/admin/Request'),
            name: 'dashboard.admin.requests',
            meta: {
              middleware: [
                auth
              ]
            }
          },
          {
            path: '/dashboard/admin/map',
            component: () => import('../views/dashboard/admin/Map'),
            name: 'dashboard.admin.map',
            meta: {
              middleware: [
                auth
              ]
            }
          },
          {
            path: '/dashboard/admin/subscribers',
            component: () => import('../views/dashboard/admin/Subscriber'),
            name: 'dashboard.admin.subscribers',
            meta: {
              middleware: [
                auth
              ]
            }
          },
          {
            path: '/dashboard/admin/mass-mailing',
            component: () => import('../views/dashboard/admin/Mass'),
            name: 'dashboard.admin.mass-mailing',
            meta: {
              middleware: [
                auth
              ]
            }
          }
        ]
      },
      {
        path: '/dashboard/user',
        component: () => import('../views/dashboard/User'),
        name: 'dashboard.user',
        meta: {
          middleware: [
            auth
          ]
        },
        beforeEnter: (to, from, next) => {
          if (store.getters.GET_USER && store.getters.GET_USER.role.includes('user')) {
            return next()
          } else {
            return next({
              name: 'dashboard'
            })
          }
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (!to.name.includes('main')) {
    store.dispatch('setRoute', true).catch()
  } else {
    store.dispatch('setRoute', false).catch()
  }
  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware
  const context = {
    to,
    from,
    next,
    store
  }
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
})

export default router
